import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

type OrderRow = {
    selected?: boolean;
    expanded?: boolean;
    level: 0 | 1;
    security: string;
    isin: string;
    type: string;
    entities: string;
    broker?: string;
    exchange: string;
    execution?: string;
    volume: string;
    estimate: string;
    price: string;
    priceCurrency?: string;
    limit: string;
    validUntil: string;
    dateHint?: string;
    investmentDecider?: string;
    cashAccount?: string;
};

@Component({
    selector: 'app-order-block-component',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './order-block.component.html',
    styleUrls: ['./order-block.component.scss'],
})

export class OrderBlockComponent {
    rows: OrderRow[] = [
        {
            expanded: true,
            level: 0,
            security: 'MICROSOFT CORP.',
            isin: 'US594918CB4',
            type: 'Market',
            entities: '2 Entities',
            broker: 'Block order',
            exchange: 'BEX',
            execution: 'Best Execution',
            volume: '18.000 USD',
            estimate: '259.554,09 USD',
            price: '62,094 %',
            limit: '-',
            validUntil: '18.08.25',
            dateHint: 'Good-till-date',
        },
        {
            level: 1,
            security: 'MICROSOFT C...',
            isin: 'US594918CC4',
            type: 'Market',
            entities: '734-0006543 CB',
            exchange: 'BEX',
            execution: 'Best Execution',
            volume: '279.000 USD',
            estimate: '173.243,01 USD',
            price: '62,094 %',
            limit: '-',
            validUntil: '18.08.25',
            cashAccount: 'Clara Brunner - Julius Bä...',
        },
        {
            level: 1,
            security: 'MICROSOFT C...',
            isin: 'US594918CC4',
            type: 'Market',
            entities: '739-0008991 LF',
            exchange: 'BEX',
            execution: 'Best Execution',
            volume: '139.000 USD',
            estimate: '86.311,03 USD',
            price: '62,094 %',
            limit: '-',
            validUntil: '18.08.25',
            cashAccount: 'Lukas Fischer - Julius Bä...',
        },
        {
            expanded: true,
            level: 0,
            security: 'Novartis AG',
            isin: 'CH0012005267',
            type: 'Market',
            entities: '2 Entities',
            broker: 'Block order',
            exchange: 'BEX',
            execution: 'Best Execution',
            volume: '2.110 Shares',
            estimate: '209.923,90 CHF',
            price: '99,49 CHF',
            limit: '-',
            validUntil: '18.08.25',
            dateHint: 'Good-till-date',
        },
    ];
}
